import { useMutation, useQueryClient } from "react-query";
import axios from "../axios";

const useKWCSendBag = ({ onSuccess, onError }) => {
  const queryClient = useQueryClient();
  const mutation = useMutation(
    async (params) => {
      return await axios.post(`/api/sendbag`, {
        type: "drop-at-location",
        requested_by: params?.requested_by,
        // noOfItems: params?.noOfItems,
        bagIds: params?.bagIds,
        locationId: params?.locationId,
      });
    },
    {
      onSuccess: (res) => {
        queryClient.invalidateQueries("seller");
        onSuccess(res);
      },
      onError: (err) => onError(err),
    }
  );

  return mutation;
};

export default useKWCSendBag;
